export const getUserStatusForEdit = (status: string): number | null => {
  switch (status) {
    case 'active':
      return 1;
    case 'inactive':
      return 0;
    case 'deleteFromUser':
      return 2;
    default:
      return null;
  }
};

export const getGenderForEdit = (gender: string): number | null => {
  switch (gender) {
    case 'female':
      return 0;
    case 'male':
      return 1;
    default:
      return null;
  }
};
